<template>
  <div>
    <Widget>
      <form-wizard
        shape="tab"
        color="#3498db"
        title=""
        subtitle=""
        @on-change="updateProgress"
        @on-loading="updateProgress(1, 1)"
      >
        <b-progress
          class="progress-xs"
          variant="info"
          :value="progress"
          :max="2"
        />
        <b-button
          slot="prev"
          id="prev-form"
          variant="primary"
          class="text-white"
          hidden
        >
          <i class="fa fa-caret-left" /> Previews
        </b-button>
        <b-button
          slot="next"
          id="next-form"
          variant="primary"
          class="text-white"
          hidden
        >
          Selanjutnya <i class="fa fa-caret-right" />
        </b-button>
        <b-button
          slot="finish"
          id="finish-form"
          variant="success"
          class="text-white"
          hidden
        >
          Selesai <i class="fa fa-check" />
        </b-button>

        <tab-content title="Profil">
          <FormProfil v-if="progress === 1" ref="form1" />
        </tab-content>

        <tab-content title="BA">
          <FormHasil v-if="progress === 2" ref="form2" />
        </tab-content>

        <div
          class="d-flex justify-content-between"
          style="padding: 14px 20px 14px 20px"
        >
          <b-button
            @click="$router.push('/app/habis-masa-berlaku')"
            id="btn_back"
            v-if="progress === 1"
            variant="danger"
            style="color: white"
          >
            Kembali
          </b-button>
          <b-button
            id="btn_previews"
            v-else
            @click="prevForm"
            variant="primary"
          >
            <i class="fa fa-caret-left" /> Sebelumnya
          </b-button>

          <b-button
            id="btn_next"
            @click="nextForm"
            variant="primary"
            style="float: right"
            :hidden="!(progress !== 2)"
          >
            Selanjutnya <i class="fa fa-caret-right" />
          </b-button>
          <b-button
            id="btn_finish"
            @click="nextForm"
            variant="success"
            style="float: right"
            :hidden="!(progress === 2)"
          >
            Selesai <i class="fa fa-check" />
          </b-button>
        </div>
      </form-wizard>
    </Widget>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget.vue'
import vSelect from 'vue-select'
import DatePicker from 'vue2-datepicker'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import FormProfil from './FormProfil.vue'
import FormHasil from './FormHasil.vue'

export default {
  components: {
    Widget,
    vSelect,
    DatePicker,
    FormProfil,
    FormHasil,
  },
  data() {
    return {
      progress: 1,
      wygEditor: ClassicEditor,
    }
  },
  methods: {
    updateProgress(prevIndex, nextIndex) {
      if (nextIndex >= 0) {
        this.progress = nextIndex + 1
      }
    },

    prevForm() {
      document.getElementById('prev-form').click()
      setTimeout(() => {
        $('html,body').scrollTop(0)
      }, 100)
    },

    async nextForm() {
      if (this.progress === 1) {
        if (await this.$refs.form1.nextForm()) {
          document.getElementById('next-form').click()
        }
      } else if (this.progress === 2) {
        if (await this.$refs.form2.nextForm()) {
          this.$router.push('/app/habis-masa-berlaku')
        }
      }
      setTimeout(() => {
        $('html,body').scrollTop(0)
      }, 500)
    },
  },
}
</script>
